// extracted by mini-css-extract-plugin
export default {"form":"ChangeForm__form--1hv","error":"ChangeForm__error--q4C","captcha":"ChangeForm__captcha--3Nf"};